'use client';

import { useEffect } from 'react';
import { useSearchParams } from '@/navigation';
import { useQueryClient } from '@tanstack/react-query';

export function NavigationEvents() {
  const search = useSearchParams();
  const returnUrl = search.get('returnUrl') ?? undefined;

  const queryClient = useQueryClient();

  useEffect(() => {
    function onSignedIn() {
      queryClient.invalidateQueries();

      const nextUrl = returnUrl?.startsWith('/sign-in') ? '/account' : returnUrl || '/account';

      location.href = `/redirect?returnUrl=${encodeURIComponent(nextUrl)}`;
    }

    onSignedIn();

    // eslint-disable-next-line react-hooks/exhaustive-deps -- exactly once
  }, []);

  return null;
}
